module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-465-min.f80e5cbe.jpg";